import React from 'react'
import './styles.css'

const EKPNumbers = () => {
  return (
    <div className="EKPNumbers--Wrapper">
      <div className="row align-items-center">
        <div className="col-md-6 col-lg-3">
          <h2>EKP v číslech</h2>
          <div className="EKPNumbers--Underline" />
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="EKPNumbers--Number">30+</div>
          <div className="EKPNumbers--Label">spolupracovníků</div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="EKPNumbers--Number">8</div>
          <div className="EKPNumbers--Label">daňových poradců</div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="EKPNumbers--Number">300+</div>
          <div className="EKPNumbers--Label">klientů</div>
        </div>
      </div>
    </div>
  )
}

export default EKPNumbers
